import React, { useMemo } from 'react';
import { selectors, useAppActions, useAppState } from 'store';
import { DataDrivenFilterType } from 'types';
import { DimensionOptionType } from '../types';

type UsePartitionProps = {
  selectedPartitionIndex?: number;
};

/**
 * Handle the logic for the partition. It connects the UI with the store.
 * @param {UsePartitionProps} param0
 * @returns
 */
const usePartition = ({ selectedPartitionIndex }: UsePartitionProps) => {
  const {
    addDataDrivenFilter,
    removeDataDrivenFilter,
    updateDataDrivenFilter,
  } = useAppActions();
  const currentPartition = useAppState(
    selectors.dataDrivenFilters.getSelectedPartitionByIndex(
      selectedPartitionIndex
    )
  );
  const dimensionOptions = useMemo(() => {
    return (currentPartition.data.dimensions || []).map((dimension) => ({
      label: dimension.ShortText,
      value: dimension.FieldGuid,
      dimension,
    }));
  }, [currentPartition]);
  const [isLoading] = React.useState(false);
  const selectedFilters = currentPartition?.data.selectedFilters || [];

  const handleOptionSelected = (
    option: DimensionOptionType,
    selectedFilterIndex: number
  ) => {
    updateDataDrivenFilter({
      selectedPartitionIndex,
      selectedFilterIndex,
      filter: {
        data: {
          dimension: option.dimension,
        },
      },
    });
  };

  const handleAddOption = () => {
    if (currentPartition?.data?.selectedFilters?.length >= 10) return;
    addDataDrivenFilter({
      selectedPartitionIndex,
    });
  };

  const handleRemoveOption = (
    DataDrivenFilter: DataDrivenFilterType,
    selectedFilterIndex: number
  ) => {
    removeDataDrivenFilter({
      selectedPartitionIndex,
      selectedFilterIndex,
      filter: DataDrivenFilter,
    });
  };

  return {
    onOptionSelected: handleOptionSelected,
    onAddOption: handleAddOption,
    onRemoveOption: handleRemoveOption,
    selectedFilters,
    dimensionOptions,
    isLoading,
  };
};

export default usePartition;
